module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/soudan_stores@3x-011d2880100b24760dbab272b809983b.webp";